(function() {
  const configEl = document.getElementById('octane-consent-config');
  const config = configEl ? JSON.parse(configEl.textContent) : {};
  const scriptUrl = config.scriptUrl || '';

  const placeholder = document.getElementById('octane-consent-placeholder');
  const placeholderContent = document.getElementById('octane-consent-content');
  const quizWrapper = document.getElementById('octane-quiz-wrapper');
  const acceptBtn = document.getElementById('octane-consent-accept');
  let quizLoaded = false;

  function showPlaceholderContent() {
    if (placeholder) placeholder.classList.remove('animate-shimmer');
    if (placeholderContent) placeholderContent.style.visibility = 'visible';
    if (acceptBtn) acceptBtn.style.visibility = 'visible';
  }

  function loadOctaneQuiz() {
    if (quizLoaded || !scriptUrl) return;
    quizLoaded = true;

    const script = document.createElement('script');
    script.src = scriptUrl;
    script.defer = true;
    document.body.appendChild(script);

    if (placeholder) placeholder.style.display = 'none';
    if (quizWrapper) quizWrapper.style.display = 'block';
  }

  async function getRequiredServices() {
    if (typeof UC_UI === 'undefined' || !UC_UI.getServicesBaseInfo) return null;

    try {
      const allServices = await UC_UI.getServicesBaseInfo();
      const result = { octane: null, analytics: null, ads: null };

      for (const s of allServices) {
        const name = (s.name || '').toLowerCase();
        if (name.includes('octane')) result.octane = s;
        else if (name.includes('google analytics')) result.analytics = s;
        else if (name.includes('google ads')) result.ads = s;
      }

      return result;
    } catch (e) {
      console.warn('Octane AI: UC_UI.getServicesBaseInfo() failed:', e);
      return null;
    }
  }

  function hasConsent(service) {
    return service && service.consent && service.consent.status === true;
  }

  async function checkAllConsents() {
    const services = await getRequiredServices();
    if (!services || !services.octane) return false;

    // Octane AI ist Pflicht
    if (!hasConsent(services.octane)) return false;

    // Google Analytics & Ads: nur prüfen wenn vorhanden
    if (services.analytics && !hasConsent(services.analytics)) return false;
    if (services.ads && !hasConsent(services.ads)) return false;

    return true;
  }

  async function acceptAllServices() {
    const services = await getRequiredServices();
    if (!services || typeof UC_UI.acceptService !== 'function') {
      loadOctaneQuiz();
      return;
    }

    if (services.octane) UC_UI.acceptService(services.octane.id);
    if (services.analytics) UC_UI.acceptService(services.analytics.id);
    if (services.ads) UC_UI.acceptService(services.ads.id);

    // Consents persistieren
    if (window.__ucCmp?.saveConsents) {
      await window.__ucCmp.saveConsents();
    }

    loadOctaneQuiz();
  }

  async function init() {
    if (await checkAllConsents()) {
      loadOctaneQuiz();
      return;
    }

    // Kein Consent: Skeleton entfernen, Placeholder-Inhalt anzeigen
    showPlaceholderContent();

    if (acceptBtn) {
      acceptBtn.addEventListener('click', acceptAllServices);
    }

    window.addEventListener('UC_CONSENT', async function() {
      if (await checkAllConsents()) {
        loadOctaneQuiz();
      }
    });
  }

  if (typeof UC_UI !== 'undefined' && UC_UI.isInitialized && UC_UI.isInitialized()) {
    init();
  } else {
    window.addEventListener('UC_UI_INITIALIZED', init);
  }
})();
